import { Component, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';

import { HeaderComponent } from '@app/layout/header/header.component';
import { getRouterData } from '@app/store/selectors';
import { Datatype } from '@app/types/datatype.enum';

@Component({
  selector: 'main-panel',
  templateUrl: './main-panel.component.html',
  styleUrl: './main-panel.component.scss',
  imports: [
    HeaderComponent,
  ],
})
export class MainPanelComponent {
  readonly #store = inject(Store);

  isTrash$: Observable<boolean> = this.#store.pipe(
    select(getRouterData),
    map((data: { id: string }) => data?.id === Datatype.TRASH),
  );
}
